import $http from '../../axios-intance';
import { Notification } from 'element-ui';
import roles, {isGroupAdvisor} from "@/util/roles";

export async function fetchSummary({ commit, state }) {
    commit('SET_LOADING', true);
    try {
        const params = buildQueryParams(state.params);
        const { data } = await $http.get('/api/sales-budget-consolidate/summary', { params });
        commit('SET_SUMMARY_DATA', data.data || []);
    } catch (error) {
        Notification.error({
            title: 'Error',
            message: error?.response?.data?.message || error.message,
            duration: 3000,
            customClass: 'notification-box'
        });
        commit('SET_SUMMARY_DATA', []);
    } finally {
        commit('SET_LOADING', false);
    }
}

export async function fetchDetail({ commit, state }, payload) {
    commit('SET_DETAIL_LOADING', true);
    try {
        const params = buildQueryParams(state.params);
        const type = state.params.reportType || 'advisor';
        if (type === 'brand') {
            // payload expected: { brandId }
            params.brand_id = payload?.brandId;
        } else if (type === 'advisor') {
            // advisor mode: payload expected: { sellerId }
            params.seller_id = payload?.sellerId;
        } else if (type === 'business') {
            params.segment_id = payload?.segmentId;
        }
        const { data } = await $http.get('/api/sales-budget-consolidate/detail', { params });
        commit('SET_DETAIL_DATA', data.data || []);
    } catch (error) {
        console.log(error)
        Notification.error({
            title: 'Error',
            message: error?.response?.data?.message || error.message,
            duration: 3000,
            customClass: 'notification-box'
        });
        commit('SET_DETAIL_DATA', []);
    } finally {
        commit('SET_DETAIL_LOADING', false);
    }
}

function buildQueryParams(params) {
    // Convierte nombres camelCase del estado a los nombres snake_case del backend
    const filters = {
        type: params.reportType || 'advisor',
        year: params.year,
        month_start: params.monthStart,
        month_end: params.monthEnd
    };

    if (Array.isArray(params.leadershipIds) && params.leadershipIds.length) {
        filters.leadership_ids = params.leadershipIds;
    }
    if (Array.isArray(params.sellerIds) && params.sellerIds.length) {
        filters.seller_ids = params.sellerIds;
    }
    if (Array.isArray(params.segmentIds) && params.segmentIds.length) {
        filters.segment_ids = params.segmentIds;
    }
    if (Array.isArray(params.brandIds) && params.brandIds.length) {
        filters.brand_ids = params.brandIds;
    }
    if (Array.isArray(params.groupedBrandIds) && params.groupedBrandIds.length) {
        filters.grouped_brand_ids = params.groupedBrandIds;
    }
    if (Array.isArray(params.customersIds) && params.customersIds.length) {
        filters.customers_ids = params.customersIds;
    }
    if (Array.isArray(params.reasonCodes) && params.reasonCodes.length) {
        filters.reason_codes = params.reasonCodes;
    }

    return filters;
}

export async function fetchGroupedBrands({ commit }, params) {
    const { data } = await $http.get('/api/marcas-agrupadas', params);
    commit('setGroupedBrands', data.data || []);
}

export async function getLeaderships({commit, state}) {
    await $http.get('/api/leaderships?all=true').then((response) => {
        commit('setLeaderships', response.data.data);
    });
}

export async function getSellers({commit, state}, reset_seller = true) {
    let leadership_id = state.params.leadershipIds;

    if (reset_seller) {
        commit('setSellerIdParams', []);
    }

    let params = {
        role: [
            ...roles.group_advisor,
            ...roles.commercial_advisors,
            ...roles.others,
        ]
    }

    if (leadership_id === null) {
        await $http.get('/api/sellers', {params}).then((response) => {
            commit('setSellersSelect', response.data.data);
        });
    } else {
        await $http.get('/api/sellers/' + leadership_id, {params}).then((response) => {
            commit('setSellersSelect', response.data.data);
        });
    }
}

export async function fetchCustomers({ commit, state }, filter) {

    if (filter.length < 3) {
        return;
    }

    commit('SET_LOADING', true);
    try {
        const params = buildQueryParams(state.params);
        params.filter = filter;
        const { data } = await $http.get('/api/contacts-filtered', { params });
        commit('setCustomers', data.data || []);
    } catch (error) {
        Notification.error({
            title: 'Error',
            message: error?.response?.data?.message || error.message,
            duration: 3000,
            customClass: 'notification-box'
        });
        commit('setCustomers', []);
    } finally {
        commit('SET_LOADING', false);
    }
}

export async function fetchLines({commit, state}, requestParameters = {params: state.params}) {
    await $http.get('/api/lineas', requestParameters)
        .then((response) => {
            commit('setLines', response.data.data)
            commit('setFinalLines', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('lineError', error.message)
        })
}
